import React, { useEffect, useState } from "react";
import { Container, ProgressBar } from "react-bootstrap";

// Função utilitária para normalizar cor e evitar erros
function normalizeColor(color, fallback) {
  if (!color) return fallback;
  let c = String(color).trim();
  if (!c.startsWith("#")) c = `#${c}`;
  return c;
}

export default function StatusObraClassic({ config }) {
  const etapas = config.statusObra?.statusList || [];

  const progressColor = normalizeColor(
    `#${config.statusObra?.progressColor}`,
    `#${config.primaryColor || "ffffff"}`
  );

  const titleColor = normalizeColor(
    config.statusObra?.titleColor,
    `#${config.secondaryColor || "0d1b2a"}`
  );

  // Divide etapas em duas colunas
  const middleIndex = Math.ceil(etapas.length / 2);
  const leftEtapas = etapas.slice(0, middleIndex);
  const rightEtapas = etapas.slice(middleIndex);

  return (
    <section
      key="statusObra"
      id="status-obra"
      style={{
        backgroundColor: `#${config.primaryColor || "262628"} `,
        paddingTop: "60px",
        paddingBottom: "60px",
        fontFamily: "Axiforma, sans-serif",
      }}
    >
      <Container style={{ maxWidth: 1000 }}>
        <h1
          className="display-5 fw-bold"
          style={{
            textAlign: "center",
            fontFamily: "Axiforma, sans-serif",
            fontSize: 35,
            color: titleColor,
          }}
        >
          STATUS DA OBRA
        </h1>

        <div style={{ display: "flex", gap: 30, marginTop: 40 }}>
          <div style={{ flex: 1 }}>
            {leftEtapas.map((etapa) => (
              <div key={etapa.status}>
                <div
                  style={{
                    fontWeight: 500,
                    marginBottom: 4,
                    color: "#fff",
                    fontSize: 17,
                    textAlign: "left",
                    fontFamily: "Axiforma, sans-serif",
                  }}
                >
                  {etapa.status}
                </div>
                <AnimatedProgressBar
                  value={etapa.percentage}
                  color={progressColor}
                />
              </div>
            ))}
          </div>
          <div style={{ flex: 1 }}>
            {rightEtapas.map((etapa) => (
              <div key={etapa.status}>
                <div
                  style={{
                    fontWeight: 500,
                    marginBottom: 4,
                    color: "#fff",
                    fontSize: 17,
                    textAlign: "left",
                    fontFamily: "Axiforma, sans-serif",
                  }}
                >
                  {etapa.status}
                </div>
                <AnimatedProgressBar
                  value={etapa.percentage}
                  color={progressColor}
                />
              </div>
            ))}
          </div>
        </div>
      </Container>
    </section>
  );
}

function AnimatedProgressBar({ value, color }) {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    let start = 0;
    const step = () => {
      if (start < value) {
        start += 1;
        setProgress(start);
        setTimeout(step, 10);
      } else {
        setProgress(value);
      }
    };
    step();
  }, [value]);

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: 10,
        marginBottom: "15px",
      }}
    >
      <span
        style={{
          width: 50,
          color: "#fff",
          fontWeight: 600,
          fontSize: "1rem",
          fontFamily: "Axiforma, sans-serif",
        }}
      >
        {progress}%
      </span>
      <div style={{ flex: 1 }}>
        <ProgressBar
          now={progress}
          style={{
            height: 12,
            borderRadius: 24,
            overflow: "hidden",
            backgroundColor: "#262628",
          }}
        >
          <ProgressBar
            now={progress}
            style={{
              height: 12,
              borderRadius: 24,
              transition: "width 0.5s",
              backgroundColor: color,
            }}
          />
        </ProgressBar>
      </div>
    </div>
  );
}
